import { render, staticRenderFns } from "./FareGroups.vue?vue&type=template&id=796b51c7&scoped=true&"
import script from "./FareGroups.vue?vue&type=script&lang=js&"
export * from "./FareGroups.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796b51c7",
  null
  
)

export default component.exports